// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

// @components
const { HireCardImageSelector } = require('components/hire/hireCardImageSelector/hireCardImageSelector');
const HireCardNameSelector = require('components/hire/hireCardNameSelector/hireCardNameSelector');

// @constants
const cardImageIds = [
    'B.506.005.001',
    'B.506.005.002',
    'B.506.005.003',
    'B.506.005.004'
];

class HireCardAtHomeAbroadStep2 extends React.Component {

    render() {
        const {
            extraImage,
            immHireCardImageSelector,
            immHireCardNameSelector,
        } = this.props;

        return (
            <article className="hire-card-at-home-abroad__step-two">
                <FormattedText
                    className="hire-card-at-home-abroad__step-title"
                    value="hireCardAtHomeAbroad-step2Title"
                />
                <HireCardImageSelector
                    cardImageIds={cardImageIds}
                    extraClass="hire-card-at-home-abroad__card-image-selector"
                    extraImage={extraImage}
                    immHireCardImageSelector={immHireCardImageSelector}
                />
                <HireCardNameSelector
                    borderTop={true}
                    immHireCardNameSelector={immHireCardNameSelector}
                />
            </article>
        );
    }
}

HireCardAtHomeAbroadStep2.propTypes = {
    extraImage: PropTypes.string,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
};

module.exports = HireCardAtHomeAbroadStep2;
